import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { isEmpty } from 'lodash'
import { MovableModalContainer } from 'components/MovableModal'
import { selectShowDeleteMediaFilesForm } from 'selectors/mainView'
import { useAction } from 'hooks'
import { showDeleMediaFilesFormAction } from 'actions/mainView'
import { ProjectMediaFilesMap } from './types'
import { DeleteMediaFilesComponent } from './DeleteMediaFilesComponent'

export const DeleteMediaFilesContainer = () => {
  const visible = useSelector(selectShowDeleteMediaFilesForm)
  const onCloseWindow = useAction(showDeleMediaFilesFormAction, { visibility: false }) as () => void
  const [ projectMediaFiles, setProjectMediaFiles ] = useState<ProjectMediaFilesMap>({})
  return (
    <MovableModalContainer
      visible={visible}
      hidden={isEmpty(projectMediaFiles)}
      restorePosition={false}
      width={540}
      height={546}
      onCloseWindow={onCloseWindow}
      withBackground
      windowId="DeleteMediaFilesContainer"
    >
      <DeleteMediaFilesComponent
        visible={visible}
        projectMediaFiles={projectMediaFiles}
        setProjectMediaFiles={setProjectMediaFiles}
      />
    </MovableModalContainer>
  )
}
